import { FILTER_TYPE } from "./filterConstants"
import {
  AlertActionFilter,
  AlertAssociatedIdFilter,
  AlertCreatedAtFilter,
  AlertKeyFilter,
  AlertStatusIconFilter,
  AlertStatusTextFilter,
  AlertSummaryFilter,
  AlertTypeFilter,
} from "./filterObjects/alertFilters"
import {
  MetaAlgIdFilter,
  MetaAlgNameFilter,
  MetaBucketFilter,
  MetaCreatedDateFilter,
  MetaFrameworkFilter,
  MetaMd5ChecksumFilter,
  MetaPathFilter,
} from "./filterObjects/algMetaFilters"
import {
  ReleaseFrameworkFilter,
  ReleaseIdFilter,
  ReleaseModelCountFilter,
  ReleaseModelIDsFilter,
  ReleaseNameFilter,
  ReleaseNormalizationFilter,
  ReleaseSensitivity,
} from "./filterObjects/algReleaseFilters"
import {
  AllowWifiImagesFilter,
  AllowWifiInsightsFilter,
  BatteryStatusFilter,
  BatteryVoltageFilter,
  CellIdFilter,
  CodeVersionFilter,
  CycleCountFilter,
  CycleTimeFilter,
  DeviceIDFilter,
  DeviceNameFilter,
  DeviceUpdateStatusFilter,
  GroupsFilter,
  HoursSinceLastCameraTriggerFilter,
  ImagesProcessedFilter,
  LastImageInHoursFilter,
  LastInsightInHoursFilter,
  LastSeenFilter,
  LatitudeFilter,
  LocationDescriptionFilter,
  LocationNameFilter,
  LongitudeFilter,
  LoraIdFilter,
  MacIdFilter,
  MapButtonFilter,
  McuVersionFilter,
  MemoryRemainingFilter,
  OnDeviceNameFilter,
  TriggerNumberFilter,
} from "./filterObjects/deviceFilters"
import {
  InsightAlgIdFilter,
  InsightAllClassNamesFilter,
  InsightClassNameFilter,
  InsightCommsSourceFilter,
  InsightConfidenceFilter,
  InsightFileCTimeFilter,
  InsightImageFilter,
  InsightStatusFilter,
  InsightTimeStampFilter,
} from "./filterObjects/insightsFilters"
import {
  OTACreatedAt,
  OTAMessage,
  OTAMessageID,
  OTAMessageIndex,
  OTAProvider,
  OTAStatus,
  OTAType,
} from "./filterObjects/otaMessageFilters"
import {
  AlgReleaseIdFilter,
  CreatedOnFilter,
  DeviceCountFilter,
  DeviceIdsFilter,
  FirmwareVersionFilter,
  OverallUpdateStatusFilter,
  UpdateCycleTimeFilter,
  UpdateIdFilter,
  UpdateTriggerNumberFilter,
} from "./filterObjects/updateFilters"
import {
  FirstNameFilter,
  LastNameFilter,
  UserEmailFilter,
  UserIdFilter,
  UserNameFilter,
  UserPhoneFilter,
} from "./filterObjects/userFilters"

// biome-ignore lint/complexity/noStaticOnlyClass: Factory Pattern
export class FilterFactory {
  static getFilter(filterType, visibility, restrictToScope, allowCompare) {
    switch (filterType) {
      case FILTER_TYPE.DEVICE.ID:
        return new DeviceIDFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.NAME:
        return new DeviceNameFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.ORIGINAL_NAME:
        return new OnDeviceNameFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LOCATION_DESC:
        return new LocationDescriptionFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LOCATION_NAME:
        return new LocationNameFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.GROUPS:
        return new GroupsFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.BATTERY_VOLTAGE:
        return new BatteryVoltageFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LATITUDE:
        return new LatitudeFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LONGITUDE:
        return new LongitudeFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.CYCLE_TIME:
        return new CycleTimeFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.TRIGGER_NUMBER:
        return new TriggerNumberFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.MEMORY_REMAINING:
        return new MemoryRemainingFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LAST_INSIGHT_HOUR:
        return new LastInsightInHoursFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LAST_IMAGE_HOUR:
        return new LastImageInHoursFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LAST_CYCLE_COUNT_HOUR:
        return new HoursSinceLastCameraTriggerFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.CYCLE_COUNT:
        return new CycleCountFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.IMAGES_PROCESSED:
        return new ImagesProcessedFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LAST_SEEN:
        return new LastSeenFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.UPDATE_STATUS:
        return new DeviceUpdateStatusFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.BATTERY_STATUS:
        return new BatteryStatusFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.MAP_BUTTON:
        return new MapButtonFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.WIFI_IMAGES:
        return new AllowWifiImagesFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.WIFI_INSIGHTS:
        return new AllowWifiInsightsFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.LORA_ID:
        return new LoraIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.CODE_VERSION:
        return new CodeVersionFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.MAC_ID:
        return new MacIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.MCU_VERISON:
        return new McuVersionFilter(visibility, restrictToScope)
      case FILTER_TYPE.DEVICE.CELL_UID:
        return new CellIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.OVERALL_STATUS:
        return new OverallUpdateStatusFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.ID:
        return new UpdateIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.ALG_RELEASE_ID:
        return new AlgReleaseIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.FIRMWARE_VERSION:
        return new FirmwareVersionFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.CREATED_ON:
        return new CreatedOnFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.CYCLE_TIME:
        return new UpdateCycleTimeFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.TRIGGER_NUMBER:
        return new UpdateTriggerNumberFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.DEVICE_COUNT:
        return new DeviceCountFilter(visibility, restrictToScope)
      case FILTER_TYPE.UPDATES.DEVICE_IDS:
        return new DeviceIdsFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALERT.ACTION:
        return new AlertActionFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALERT.STATUS_ICON:
        return new AlertStatusIconFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALERT.STATUS_TEXT:
        return new AlertStatusTextFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALERT.TYPE:
        return new AlertTypeFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALERT.SUMMARY:
        return new AlertSummaryFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALERT.KEY:
        return new AlertKeyFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALERT.ASSOCIATED_ID:
        return new AlertAssociatedIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALERT.CREATED_AT:
        return new AlertCreatedAtFilter(visibility, restrictToScope)
      case FILTER_TYPE.INSIGHT.CLASS_NAME:
        return new InsightClassNameFilter(visibility, restrictToScope, allowCompare)
      case FILTER_TYPE.INSIGHT.ALL_CLASS_NAMES:
        return new InsightAllClassNamesFilter(visibility, restrictToScope)
      case FILTER_TYPE.INSIGHT.ALG_ID:
        return new InsightAlgIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.INSIGHT.CONFIDENCE:
        return new InsightConfidenceFilter(visibility, restrictToScope)
      case FILTER_TYPE.INSIGHT.TIMESTAMP:
        return new InsightTimeStampFilter(visibility, restrictToScope)
      case FILTER_TYPE.INSIGHT.FILE_CTIME:
        return new InsightFileCTimeFilter(visibility, restrictToScope)
      case FILTER_TYPE.INSIGHT.COMMS_SOURCE:
        return new InsightCommsSourceFilter(visibility, restrictToScope)
      case FILTER_TYPE.INSIGHT.IMAGE:
        return new InsightImageFilter(visibility, restrictToScope)
      case FILTER_TYPE.INSIGHT.STATUS:
        return new InsightStatusFilter(visibility, restrictToScope)
      case FILTER_TYPE.USER.ID:
        return new UserIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.USER.EMAIL:
        return new UserEmailFilter(visibility, restrictToScope)
      case FILTER_TYPE.USER.FIRST_NAME:
        return new FirstNameFilter(visibility, restrictToScope)
      case FILTER_TYPE.USER.LAST_NAME:
        return new LastNameFilter(visibility, restrictToScope)
      case FILTER_TYPE.USER.USERNAME:
        return new UserNameFilter(visibility, restrictToScope)
      case FILTER_TYPE.USER.PHONE_NUMBER:
        return new UserPhoneFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_META.ID:
        return new MetaAlgIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_META.NAME:
        return new MetaAlgNameFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_META.FRAMEWORK:
        return new MetaFrameworkFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_META.DATE_CREATED:
        return new MetaCreatedDateFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_META.BUCKET:
        return new MetaBucketFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_META.PATH:
        return new MetaPathFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_META.CHECKSUM:
        return new MetaMd5ChecksumFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_RELEASE.ID:
        return new ReleaseIdFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_RELEASE.NAME:
        return new ReleaseNameFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_RELEASE.FRAMEWORK:
        return new ReleaseFrameworkFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_RELEASE.MODEL_COUNT:
        return new ReleaseModelCountFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_RELEASE.MODEL_IDS:
        return new ReleaseModelIDsFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_RELEASE.NORMALIZATION:
        return new ReleaseNormalizationFilter(visibility, restrictToScope)
      case FILTER_TYPE.ALG_RELEASE.SENSITIVITY:
        return new ReleaseSensitivity(visibility, restrictToScope)
      case FILTER_TYPE.OTA_MESSAGE.CREATED_AT:
        return new OTACreatedAt(visibility, restrictToScope)
      case FILTER_TYPE.OTA_MESSAGE.ID:
        return new OTAMessageID(visibility, restrictToScope)
      case FILTER_TYPE.OTA_MESSAGE.MESSAGE:
        return new OTAMessage(visibility, restrictToScope)
      case FILTER_TYPE.OTA_MESSAGE.PROVIDER:
        return new OTAProvider(visibility, restrictToScope)
      case FILTER_TYPE.OTA_MESSAGE.STATUS:
        return new OTAStatus(visibility, restrictToScope)
      case FILTER_TYPE.OTA_MESSAGE.TYPE:
        return new OTAType(visibility, restrictToScope)
      case FILTER_TYPE.OTA_MESSAGE.INDEX:
        return new OTAMessageIndex(visibility, restrictToScope)
      default:
        throw new Error("No filter with this type.")
    }
  }
}
